import { useGetBreeds } from '@application/api';
import { useRouter } from '@application/utils';
import { useMemo } from 'react';

export const useSeo = () => {
  const { translate, language, infoFromCurrentPath } = useRouter();
  const { breedOptionsBasenameKey } = useGetBreeds();

  const breedName = useMemo(() => {
    const breedFromPathParam = infoFromCurrentPath.params?.length
      ? infoFromCurrentPath.params[0]
          .split(',')
          .map((x) => decodeURI(x))
          .pop()
      : null;

    if (breedFromPathParam) {
      // HACK for specific breeds, we want this exact breedname for SEO purposes
      if (breedFromPathParam === 'germanspitz') {
        return language === 'fr' ? 'Spitz Nain' : 'Pomeranian';
      }
      if (breedFromPathParam === 'dachshund') {
        return 'Teckel';
      }
      return breedOptionsBasenameKey
        .find((item) => item.value === breedFromPathParam)
        ?.label?.toString();
    }
  }, [breedOptionsBasenameKey, infoFromCurrentPath.params, language]);

  const seoTitle = useMemo(() => {
    if (breedName) {
      return translate('litterList.seo.breed.title').replace('$breed', breedName);
    }
    return translate('litterList.seo.default.title');
  }, [breedName, translate]);

  const seoDescription = useMemo(() => {
    if (breedName) {
      return translate('litterList.seo.breed.description').replace('$breed', breedName);
    }
    return translate('litterList.seo.default.description');
  }, [breedName, translate]);

  const pageTitle = useMemo(() => {
    if (breedName) {
      return translate('litterList.title.breed').replace('$breed', breedName);
    }
    return translate('litterList.title.default');
  }, [breedName, translate]);

  return { seoTitle, seoDescription, pageTitle, breedName };
};
